var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconOhneSchlossOff = function SvgIconOhneSchlossOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 10C21.6689 10 23.2423 10.4088 24.6255 11.1318L23.1243 12.6331C22.1644 12.2255 21.1085 12 19.9999 12C15.5817 12 12 15.5817 12 20C12 21.1086 12.2255 22.1644 12.6331 23.1243L11.1318 24.6256C10.4088 23.2423 10 21.6689 10 20C10 14.4772 14.4771 10 19.9999 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2619 17.5148C17.8216 16.8895 18.5865 16.4514 19.4507 16.3067L16.5625 19.1948H16.2993C15.8362 19.1948 15.4595 19.5716 15.4595 20.0346C15.4595 20.1147 15.4708 20.1921 15.4918 20.2655L14.2526 21.5048C13.9549 21.091 13.7795 20.5833 13.7795 20.0346C13.7795 18.6428 14.9075 17.5148 16.2993 17.5148H17.2619Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.807 18.4357L24.6012 19.6415C24.6636 19.7588 24.699 19.8926 24.699 20.0346C24.699 20.4976 24.3223 20.8743 23.8593 20.8743H23.3683L20.4456 23.7971C21.4172 23.7036 22.2812 23.2424 22.897 22.5543H23.8593C25.2511 22.5543 26.379 21.4264 26.379 20.0346C26.379 19.4275 26.1644 18.8707 25.807 18.4357Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 28C18.8914 28 17.8355 27.7745 16.8757 27.367L15.3744 28.8682C16.7576 29.5912 18.331 30 19.9999 30C25.5228 30 29.9999 25.5229 29.9999 20C29.9999 18.3311 29.5911 16.7577 28.8681 15.3745L27.3669 16.8758C27.7744 17.8356 27.9999 18.8915 27.9999 20C27.9999 24.4183 24.4182 28 19.9999 28Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7071 12.7071C29.0976 12.3166 29.0976 11.6834 28.7071 11.2929C28.3166 10.9024 27.6834 10.9024 27.2929 11.2929L11.2929 27.2929C10.9024 27.6834 10.9024 28.3166 11.2929 28.7071C11.6834 29.0976 12.3166 29.0976 12.7071 28.7071L28.7071 12.7071Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconOhneSchlossOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-ohne-schloss-off.38d0639a.svg";
export { ForwardRef as ReactComponent };